__turbopack_context__.v({
  "emptyCell": "data-table-module__Hv11yq__emptyCell",
  "row": "data-table-module__Hv11yq__row",
  "rowClickable": "data-table-module__Hv11yq__rowClickable",
  "sortIndicator": "data-table-module__Hv11yq__sortIndicator",
  "table": "data-table-module__Hv11yq__table",
  "tableWrapper": "data-table-module__Hv11yq__tableWrapper",
  "td": "data-table-module__Hv11yq__td",
  "tdCheckbox": "data-table-module__Hv11yq__tdCheckbox",
  "th": "data-table-module__Hv11yq__th",
  "thCheckbox": "data-table-module__Hv11yq__thCheckbox",
  "thContent": "data-table-module__Hv11yq__thContent",
  "thSortable": "data-table-module__Hv11yq__thSortable",
});
